import { Box, Skeleton } from '@mui/material';
import { useSearch, useSiteContext } from 'src/store';

import { ISearchFilter } from '@orcha/types/search';
import React from 'react';
import useSearchFilters from 'src/hooks/useSearchFilters';
import { FiltersContainer } from './Filters.styles';
import { ArrayFilter, BooleanFilter, GroupedArrayFilter } from './FilterTypes';

export const Filters = () => {
  const DEFAULT_LOADING_COUNT = 7;
  const { appliedFilters, updateAppliedFilters } = useSearch();
  const { searchConfig } = useSiteContext();

  const searchFilters = useSearchFilters();

  const loadingCount = searchConfig?.filterOptions
    ? searchConfig.filterOptions.length
    : DEFAULT_LOADING_COUNT;

  const booleans = searchFilters?.filters?.filter(
    (filter) => filter.dataType === 'Boolean'
  );
  const arrays = searchFilters?.filters?.filter(
    (filter) => filter.dataType !== 'Boolean'
  );
  return (
    <Box display="grid" gap={2}>
      <FiltersContainer>
        {searchFilters?.isLoading
          ? [...Array(loadingCount)].map((e, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton key={i} variant="rounded" height={35} component="div" />
            ))
          : arrays?.map((filter: ISearchFilter) => {
              if (filter.dataType === 'GroupedArray') {
                return (
                  <GroupedArrayFilter
                    key={filter.filterName}
                    filter={filter}
                    selectedOptions={
                      appliedFilters?.find(
                        (a) => a.filterName === filter.filterName
                      )?.selectedOptions ?? []
                    }
                    handleSelectedChange={(selectedOptions: string[]) => {
                      updateAppliedFilters(filter.filterName, selectedOptions);
                    }}
                  />
                );
              }
              if (filter.dataType === 'StringArray') {
                return (
                  <ArrayFilter
                    key={filter.filterName}
                    filter={filter}
                    selectedOptions={
                      appliedFilters?.find(
                        (a) => a.filterName === filter.filterName
                      )?.selectedOptions ?? []
                    }
                    handleSelectedChange={(selectedOptions: string[]) => {
                      updateAppliedFilters(filter.filterName, selectedOptions);
                    }}
                  />
                );
              }
              return <></>;
            })}
      </FiltersContainer>

      {booleans?.map((filter: ISearchFilter) => {
        return (
          <BooleanFilter
            key={filter.filterName}
            filter={filter}
            selectedOptions={
              appliedFilters?.find((a) => a.filterName === filter.filterName)
                ?.selectedOptions ?? []
            }
            handleSelectedChange={(selectedOptions: string[]) => {
              updateAppliedFilters(filter.filterName, selectedOptions);
            }}
          />
        );
      })}
    </Box>
  );
};

export default Filters;
